import { useEffect, useMemo, Fragment, useContext } from "react"
import { PreviousShiftEvent, ShiftInterface } from "types/workMonitor.types"
import { ShiftStatus, platformTypeENUM } from "config/constants"
// import IncidentView from "pages/schedules/Location/IncidentInfo"
import { useAppDispatch } from "hooks"
import { getUsers } from "store/Security/users.slice"
import ShiftEventCard from "./ShiftEventCard"
import QRCard from "./QRCard"
import cx from "classnames"
import moment from "moment"
import { Icon } from "components"
import ShiftEventsRetainContext from "pages/schedules/Location/ShiftEventsContext"
import ShiftActivityVisualizationModal from "components/ShiftActivityVisualizationModal"

interface Props {
	shift: ShiftInterface | null
	containerClass?: string
	showVisualizeActivity?: boolean
}

const getShiftStatusColor = (events: PreviousShiftEvent): string => {
	return cx({
		"bg-[#01A66F]": events["status"] === ShiftStatus.BOOKON,
		"bg-[red]":
			(moment(events["dueTime"]).isValid()
				? moment(events["dueTime"]) < moment(events["eventTime"])
				: events["dueTime"] < moment(events["eventTime"]).format("HH:mm")) &&
			events["status"] === ShiftStatus.BOOKON,

		"bg-[#312e81]": events["status"] === ShiftStatus.CHECK,
		"bg-[#8E4306]": events["status"] === ShiftStatus.INVENTORY,
		"bg-[#3D5A80]": events["status"] === ShiftStatus.QR,
		"bg-[#D62828]": events["status"] === ShiftStatus.BOOKOFF,
	})
}

const WorkMonitorView: React.FC<Props> = ({
	shift = null,
	containerClass = "h-full",
	showVisualizeActivity = false,
}) => {
	const dispatch = useAppDispatch()

	const { loadingShiftActivity } = useContext(ShiftEventsRetainContext)

	useEffect(() => {
		dispatch(getUsers(platformTypeENUM.MOBILE))
	}, [])

	const filteredShiftEvents = useMemo(() => {
		return shift?.shiftEvents?.filter(events => events.status !== ShiftStatus.CHASED) || []
	}, [shift])

	return (
		<div className={containerClass}>
			{loadingShiftActivity ? (
				<div className="flex h-full w-full flex-1 items-center justify-center">
					<Icon name="spinner" size={30} color="black" className="relative animate-spin" />
				</div>
			) : (
				!!filteredShiftEvents?.length && (
					<>
						<div className="flex items-center justify-between py-4 px-2">
							<span className="text-center text-lg font-semibold tracking-wide">Shift Events</span>
							{showVisualizeActivity && (
								<ShiftActivityVisualizationModal shiftActivity={shift?.shiftEvents ?? []} />
							)}
						</div>
						{filteredShiftEvents.map(events => {
							const shiftStatusColor = getShiftStatusColor(events)
							return (
								<Fragment key={events?._id}>
									{events.status !== ShiftStatus.QR ? (
										<ShiftEventCard
											key={events._id}
											events={events}
											containerClass={containerClass}
											shiftStatusColor={shiftStatusColor}
										/>
									) : (
										<QRCard events={events} key={events._id} shiftStatusColor={shiftStatusColor} />
									)}
								</Fragment>
							)
						})}
					</>
				)
			)}
		</div>
	)
}

export default WorkMonitorView
